<template>
  <div :id="id" :style="`height:${height};`"></div>
</template>

<script>
  import * as echarts from 'echarts'
  import china from '@/assets/map/china'

  export default {
    name: 'MapChina',
    props: ['id', 'datas', 'height', 'month'],
    data() {
      return {}
    },
    mounted() {
    	this.draw()
    },
    watch: {
      datas: {
        handler (newV, oldV) {
          this.clear()
          this.draw()
        },
        deep: true
      }
    },
    beforeDestroy() {
    	this.clear()
    },
    methods: {
      clear() {
        echarts.dispose(this.myChart)
        this.myChart = null
      },
      draw() {
        if (document.getElementById(this.id) == null) {
          return
        }
        echarts.dispose(document.getElementById(this.id))
        this.myChart = echarts.init(document.getElementById(this.id))
        echarts.registerMap('china', china)
        this.myChart.on('click', params => {
          let id = params.name
          // if(this.checkValue(id).length && this.checkValue(id)[0].value) {
          if(this.checkValue(id).length) {
            this.$router.push({path:`/other/target/${id}`, query:{month: this.month}})
          } else {
            this.$message({
              message: '暂无权限',
              type: 'warning',
              duration: 1000
            })
          }
        })
        this.myChart.setOption({
          visualMap: {
            type: 'piecewise',
            pieces: [
              {get: 1, label: '优', color: '#39eef1'},
              {get: 0.6, lt: 1, label: '中', color: '#deff00'},
              {lt: 0.6, label: '差', color: '#fc4318'},
            ],
            left: 10,
            bottom: 10,
            itemWidth: 12,
            itemHeight: 6,
            textGap: 6,
            itemGap: 6,
            textStyle: {
              fontSize: 8,
              color: 'rgba(255, 255, 255, .6)'
            }
          },
          series: [{
            name: '',
            type: 'map',
            map: 'china',
            zoom: 1.2,
            label: {
              show: true,
              fontSize: 6,
              color: 'rgba(255, 255, 255, .8)',
              textBorderColor: '#6980ff',
              textBorderWidth: 1,
              textBorderType: 'solid'
            },
            itemStyle: {
              borderColor: 'rgba(255, 255, 255, .4)',
              areaColor: '#3247c6',
            },
            select: {
              itemStyle: {
                areaColor: '#1a2a84'
              }
            },
            data: this.datas,
          }]
        }, true)
      },
      checkValue(e) {
        if(!this.datas) {return}
        return this.datas.filter((item) => item.name == e )
      }
    }
  }
</script>

<style>
</style>
